import { render, staticRenderFns } from "./SkuReturnReasons.vue?vue&type=template&id=2e57baec&"
import script from "./SkuReturnReasons.vue?vue&type=script&lang=js&"
export * from "./SkuReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./SkuReturnReasons.vue?vue&type=style&index=0&id=2e57baec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports